import {
  Document,
  DocumentType,
  FileDto,
  FileStatus
} from './Document.interface';

const filePathRegex = new RegExp(
  /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^/]+?|)(\.[^./]*|))(?:[\\/]*)$/
);
export interface FileStatusStruct {
  name: string;
  value: FileStatus;
}

export const FILE_STATUSES: FileStatusStruct[] = [
  { name: 'Draft', value: FileStatus.Draft },
  { name: 'In Review', value: FileStatus.InReview },
  { name: 'Approved', value: FileStatus.Approved }
  // { name: 'Declined', value: 'declined' }
];

export type DocumentMap = {
  [name in FileStatus]: Document[];
};

// use function to avoid retaining array reference
export const createEmptyDocumentMap = (): DocumentMap => ({
  draft: [],
  'in-review': [],
  approved: [],
  obsolete: []
});

export function convertFileToDocument(file: FileDto): Document {
  return {
    ...file,
    type: file.isFolder ? DocumentType.Folder : DocumentType.File
  } as Document;
}

export const mapDocumentsByStatus = (
  documents: Document[],
  documentMap?: DocumentMap
): DocumentMap => {
  documentMap = (documentMap || { ...createEmptyDocumentMap() }) as DocumentMap;
  return documents.reduce((documentMap: DocumentMap, document: Document) => {
    const { status } = document.fileVersion || {};
    if (status) {
      // add array if non existent
      if (!documentMap[status]) {
        documentMap[status] = [];
      }
      documentMap[status].push(document);
    }
    return documentMap;
  }, documentMap);
};

export const parseFilePath = (
  pathString: string
): {
  root: string;
  dir: string;
  base: string;
  ext: string;
  name: string;
} => {
  if (typeof pathString !== 'string') {
    throw new TypeError(
      "Parameter 'pathString' must be a string, not " + typeof pathString
    );
  }
  var allParts = filePathRegex.exec(pathString)?.slice(1);
  if (!allParts || allParts.length !== 4) {
    throw new TypeError("Invalid path '" + pathString + "'");
  }
  allParts[1] = allParts[1] || '';
  allParts[2] = allParts[2] || '';
  allParts[3] = allParts[3] || '';

  return {
    root: allParts[0],
    dir: allParts[0] + allParts[1].slice(0, -1),
    base: allParts[2],
    ext: allParts[3],
    name: allParts[2].slice(0, allParts[2].length - allParts[3].length)
  };
};

export const FILE_TYPES = {
  msoffice: ['doc', 'docx', 'xls', 'xlsx', 'xlsm', 'ppt', 'pptx'],
  images: [
    'jpg',
    'jpeg',
    'png',
    'gif',
    'svg',
    'apng',
    'avif',
    'jfif',
    'webp',
    'pjpeg',
    'pjp',
    'bmp',
    'tiff',
    'tif'
  ],
  video: [
    '3g2',
    '3gp',
    'avi',
    'flv',
    'h264',
    'm4v',
    'mkv',
    'mov',
    'mp4',
    'mpeg',
    'mpg',
    'webm',
    'wmv'
  ],
  audio: [
    'aac',
    'aif',
    'cda',
    'flac',
    'm4a',
    'mid',
    'midi',
    'mp3',
    'mpga',
    'oga',
    'ogg',
    'wav'
  ],
  text: ['txt', 'text', 'json', 'xml', 'html', 'xhtml', 'htm', 'md'],
  compressed: ['7z', 'arj', 'deb', 'pkg', 'rar', 'rpm', 'gz', 'z', 'zip']
};
